/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InvestmentDetailsProductViewModel } from './InvestmentDetailsProductViewModel';
import {
    InvestmentDetailsProductViewModelFromJSON,
    InvestmentDetailsProductViewModelFromJSONTyped,
    InvestmentDetailsProductViewModelToJSON,
} from './InvestmentDetailsProductViewModel';

/**
 * 
 * @export
 * @interface InvestmentDetailsScenarioViewModel
 */
export interface InvestmentDetailsScenarioViewModel {
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsScenarioViewModel
     */
    scenarioId: number;
    /**
     * 
     * @type {boolean}
     * @memberof InvestmentDetailsScenarioViewModel
     */
    isSelectedScenario: boolean;
    /**
     * 
     * @type {Array<InvestmentDetailsProductViewModel>}
     * @memberof InvestmentDetailsScenarioViewModel
     */
    products: Array<InvestmentDetailsProductViewModel>;
}

/**
 * Check if a given object implements the InvestmentDetailsScenarioViewModel interface.
 */
export function instanceOfInvestmentDetailsScenarioViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "scenarioId" in value;
    isInstance = isInstance && "isSelectedScenario" in value;
    isInstance = isInstance && "products" in value;

    return isInstance;
}

export function InvestmentDetailsScenarioViewModelFromJSON(json: any): InvestmentDetailsScenarioViewModel {
    return InvestmentDetailsScenarioViewModelFromJSONTyped(json, false);
}

export function InvestmentDetailsScenarioViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestmentDetailsScenarioViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'scenarioId': json['ScenarioId'],
        'isSelectedScenario': json['IsSelectedScenario'],
        'products': ((json['Products'] as Array<any>).map(InvestmentDetailsProductViewModelFromJSON)),
    };
}

export function InvestmentDetailsScenarioViewModelToJSON(value?: InvestmentDetailsScenarioViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ScenarioId': value.scenarioId,
        'IsSelectedScenario': value.isSelectedScenario,
        'Products': ((value.products as Array<any>).map(InvestmentDetailsProductViewModelToJSON)),
    };
}

